import { render, staticRenderFns } from "./MaskeAusbildungsplan.vue?vue&type=template&id=4896701a&scoped=true"
import script from "./MaskeAusbildungsplan.vue?vue&type=script&lang=js"
export * from "./MaskeAusbildungsplan.vue?vue&type=script&lang=js"
import style0 from "./MaskeAusbildungsplan.vue?vue&type=style&index=0&id=4896701a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4896701a",
  null
  
)

export default component.exports